export const PUBLIC_INSURANCES = [
  {
    key: 'bkk_firmus_de',
    name: 'BKK firmus',
  },
  {
    key: 'hkk_de',
    name: 'hkk',
  },
  {
    key: 'audibkk_de',
    name: 'Audi BKK',
  },
  {
    key: 'techniker_krankenkasse_de',
    name: 'Techniker Krankenkasse',
  },
  {
    key: 'wmf_bkk_de',
    name: 'WMF BKK',
  },
  {
    key: 'hek_de',
    name: 'HEK',
  },
  {
    key: 'bkk_linde_de',
    name: 'BKK Linde',
  },
  {
    key: 'tui_bkk_de',
    name: 'TUI BKK',
  },
  {
    key: 'dak_gesundheit_de',
    name: 'DAK-Gesundheit',
  },
  {
    key: 'bkk_verbundplus_de',
    name: 'BKK VerbundPlus',
  },
  {
    key: 'bkk_provita_de',
    name: 'BKK ProVita',
  },
  {
    key: 'sbk_de',
    name: 'SBK',
  },
  {
    key: 'r_v_bkk_de',
    name: 'R + V BKK',
  },
  {
    key: 'energie_bkk_de',
    name: 'energie-BKK',
  },
  {
    key: 'novitas_bkk_de',
    name: 'Novitas BKK',
  },
  {
    key: 'salus_bkk_de',
    name: 'Salus BKK',
  },
  {
    key: 'heimat_krankenkasse_de',
    name: 'Heimat Krankenkasse',
  },
  {
    key: 'securvita_de',
    name: 'SECURVITA',
  },
  {
    key: 'pronova_bkk_de',
    name: 'Pronova BKK',
  },
  {
    key: 'bertelsmann_bkk_de',
    name: 'Bertelsmann BKK',
  },
  {
    key: 'bkk_24_de',
    name: 'BKK 24',
  },
  {
    key: 'debeka_bkk_de',
    name: 'Debeka BKK',
  },
  {
    key: 'viactiv_krankenkasse_de',
    name: 'VIACTIV Krankenkasse',
  },
  {
    key: 'barmer_de',
    name: 'BARMER',
  },
  {
    key: 'die_continentale_bkk_de',
    name: 'Die Continentale BKK',
  },
  {
    key: 'big_direkt_gesund_de',
    name: 'BIG direkt gesund',
  },
  {
    key: 'ikk_gesund_plus_de',
    name: 'IKK gesund plus',
  },
  {
    key: 'ikk_classic_de',
    name: 'IKK classic',
  },
  {
    key: 'bahn_bkk_de',
    name: 'BAHN BKK',
  },
  {
    key: 'bkk_gildemeister_seidensticker_de',
    name: 'BKK GILDEMEISTER SEIDENSTICKER',
  },
  {
    key: 'mkk_meine_krankenkasse_de',
    name: 'mkk - meine krankenkasse',
  },
  {
    key: 'ikk_die_innovationskasse_de',
    name: 'IKK - Die Innovationskasse',
  },
  {
    key: 'kkh_kaufmaennische_krankenkasse_de',
    name: 'KKH Kaufmännische Krankenkasse',
  },
  {
    key: 'vivida_bkk_de',
    name: 'vivida bkk',
  },
  {
    key: 'mobil_krankenkasse_de',
    name: 'Mobil Krankenkasse',
  },
  {
    key: 'bkk_pfalz_de',
    name: 'BKK Pfalz',
  },
  {
    key: 'knappschaft_de',
    name: 'Knappschaft',
  },
  {
    key: 'bkk_faber_castell_partner_de',
    name: 'BKK Faber-Castell & Partner',
  },
  {
    key: 'bkk_public_de',
    name: 'BKK Public',
  },
  {
    key: 'bkk_exklusiv_de',
    name: 'BKK exklusiv',
  },
  {
    key: 'bkk_sbh_de',
    name: 'BKK SBH',
  },
  {
    key: 'aok_rheinland_pfalz_saarland_de',
    name: 'AOK Rheinland-Pfalz/Saarland',
  },
  {
    key: 'skd_bkk_de',
    name: 'SKD BKK',
  },
  {
    key: 'aok_bremen_und_bremerhaven_de',
    name: 'AOK Bremen und Bremerhaven',
  },
  {
    key: 'aok_hessen_de',
    name: 'AOK Hessen',
  },
  {
    key: 'bkk_freudenberg_de',
    name: 'BKK Freudenberg',
  },
  {
    key: 'bkk_technoform_de',
    name: 'BKK Technoform',
  },
  {
    key: 'aok_sachsen_anhalt_de',
    name: 'AOK Sachsen-Anhalt',
  },
  {
    key: 'mhplus_krankenkasse_de',
    name: 'mhplus Krankenkasse',
  },
  {
    key: 'aok_baden_wuerttemberg_de',
    name: 'AOK Baden-Württemberg',
  },
  {
    key: 'bosch_bkk_de',
    name: 'Bosch BKK',
  },
  {
    key: 'aok_bayern_de',
    name: 'AOK Bayern',
  },
  {
    key: 'aok_niedersachsen_de',
    name: 'AOK Niedersachsen',
  },
  {
    key: 'bkk_scheufelen_de',
    name: 'BKK Scheufelen',
  },
  {
    key: 'bkk_pfaff_de',
    name: 'BKK PFAFF',
  },
  {
    key: 'aok_nordwest_de',
    name: 'AOK Nordwest',
  },
  {
    key: 'die_bergische_de',
    name: 'Die BERGISCHE',
  },
  {
    key: 'aok_rheinland_hamburg_de',
    name: 'AOK Rheinland/Hamburg',
  },
  {
    key: 'bkk_wirtschaft_und_finanzen_de',
    name: 'BKK WIRTSCHAFT UND FINANZEN',
  },
  {
    key: 'aok_plus_de',
    name: 'AOK Plus',
  },
  {
    key: 'ikk_brandenburg_und_berlin_de',
    name: 'IKK Brandenburg und Berlin',
  },
  {
    key: 'bkk_vdn_de',
    name: 'BKK VDN',
  },
  {
    key: 'ikk_suedwest_de',
    name: 'IKK Südwest',
  },
  {
    key: 'bkk_werra_meissner_de',
    name: 'BKK Werra-Meissner',
  },
  {
    key: 'bkk_euregio_de',
    name: 'BKK Euregio',
  },
  {
    key: 'bkk_akzo_nobel_de',
    name: 'BKK Akzo Nobel',
  },
  {
    key: 'bkk_zf_partner_de',
    name: 'BKK ZF & Partner',
  },
  {
    key: 'bkk_herkules_de',
    name: 'BKK HERKULES',
  },
  {
    key: 'aok_nordost_de',
    name: 'AOK Nordost',
  },
  {
    key: 'bkk_melitta_hmr_de',
    name: 'BKK Melitta HMR',
  },
  {
    key: 'bkk_diakonie_de',
    name: 'BKK Diakonie',
  },
  {
    key: 'bkk_duerkoppadler_de',
    name: 'BKK DürkoppAdler',
  },
]
